import * as React from "react";
import { Select } from "baseui/select";
import { FormControl } from 'baseui/form-control';
// api 
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { ISP_Room, RoomTypes } from './types'
import { LabelSmall, ParagraphSmall } from "baseui/typography";
import { FormattedMessage } from "react-intl";
import { Block } from "baseui/block";
import { useStyletron } from "baseui";
import { OptimalConditionsText } from "./OptimalConditionsText";



export function ConfigurationPanel(props: ISP_Room) {
    const [, theme] = useStyletron();
    const [usage, setUsage, setUsageResult] = useSetObjectValue(props.id, props.resourceGroupId, "usage", props.usage);
    const onValueChanged = (e: any) => setUsage(e.option.id);
    const selected = RoomTypes.find(v => v.id === usage);
    const value: any[] = [
        selected
    ];

    return (
        <Block display={'flex'} flexDirection={'column'} gridGap={theme.sizing.scale400}>
            <FormControl label={<FormattedMessage id="SubPlants.RoomUsage" defaultMessage="Room Usage" />} caption={<FormattedMessage id="SubPlants.TextRoomUsage" defaultMessage="Select the most appropriate room type" />}>
                <Select
                    value={value}
                    valueKey='id'
                    clearable={false}
                    searchable={false}
                    onChange={onValueChanged}
                    options={RoomTypes}
                />
            </FormControl>
            <OptimalConditionsText roomUsage={usage}></OptimalConditionsText>
        </Block>
    );


}






